import { gql } from "@apollo/client";

export const listRewardUnits = gql`
  query ListRewardUnits($filter: RewardUnitFilter, $page: Int, $size: Int) {
    listRewardUnits(filter: $filter, page: $page, size: $size) {
      items {
        id
        name
        description
        type
        unit
      }
    }
  }
`;
